import React from "react";
import { InfoIconEvolutive } from "src/components/Icons";
import * as Ui from "./styles";

export default function Tooltip({ toolTipTitle }) {
  return (
    <Ui.ContainerTooltip className="tooltipContainer">
      <InfoIconEvolutive />
      <Ui.TooltipTitle>{toolTipTitle}</Ui.TooltipTitle>
    </Ui.ContainerTooltip>
  );
};